import { ConnectorIcon } from "@mirage/shared/icons";

import type {
  ConnectorFilter,
  SearchFilter,
} from "@mirage/shared/search/search-filters";
import { t } from "i18next";
import { useMemo } from "react";
import { useFilterSearch } from "../CategorySearchAccordion/useFilterSearch";
import { FilterRow } from "./FilterRow";

const RESPONSE_LENGTH_LIMIT = 100;

type AppFilterRowProps = {
  query: string;
  filter: ConnectorFilter;
  seeAllForFilter: (filter: SearchFilter) => void;
  shouldSkipCache?: boolean;
};

export const AppFilterRow = ({
  query,
  filter,
  seeAllForFilter,
  shouldSkipCache,
}: AppFilterRowProps) => {
  const { results, loading } = useFilterSearch(
    query,
    filter,
    null,
    shouldSkipCache,
  );
  const countLabel = useMemo(() => {
    if (loading) return "";
    return results.length === RESPONSE_LENGTH_LIMIT
      ? t("count_plus", {
          count: RESPONSE_LENGTH_LIMIT,
        })
      : `${results.length}`;
  }, [results.length, loading]);

  return (
    <FilterRow
      key={filter.id}
      title={filter.parameters.displayName}
      icon={
        <ConnectorIcon
          connectorName={filter.id}
          iconUrl={
            filter.parameters.iconDarkSrc
              ? filter.parameters.iconDarkSrc
              : filter.parameters.iconLightSrc
          }
          size={16}
        />
      }
      countLabel={countLabel}
      onClick={() => {
        seeAllForFilter(filter);
      }}
      loading={loading}
    />
  );
};
